// extracted by mini-css-extract-plugin
export default {"componentLabel":"styles_componentLabel__EfvTF","midweekFlex":"styles_midweekFlex__qCNw1","midweekBox":"styles_midweekBox__FRXrU"};